module.exports = __webpack_public_path__ + "static/media/santuario-nacional-virgen-coromoto.fe435ab8.png";